module.exports = __webpack_public_path__ + "media/images/index/line2-7846eb9496ba256f63adc6972ea1c4c8.svg";